var map = {
	"./da-DK.json": 26531,
	"./de-DE.json": 16899,
	"./en-GB.json": 43469,
	"./en-US.json": 61851,
	"./es-ES.json": 97620,
	"./fr-FR.json": 17237,
	"./hu-HU.json": 16250,
	"./pl-PL.json": 63637,
	"./ru-RU.json": 55018,
	"./sv-SE.json": 86530,
	"@/i18n/da-DK.json": 26531,
	"@/i18n/de-DE.json": 16899,
	"@/i18n/en-GB.json": 43469,
	"@/i18n/en-US.json": 61851,
	"@/i18n/es-ES.json": 97620,
	"@/i18n/fr-FR.json": 17237,
	"@/i18n/hu-HU.json": 16250,
	"@/i18n/pl-PL.json": 63637,
	"@/i18n/ru-RU.json": 55018,
	"@/i18n/sv-SE.json": 86530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77808;